/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CouponBatchDto { 
    id: string;
    couponId: string;
    externalId?: string;
    minimumSpend?: number;
    discountType: CouponBatchDto.DiscountTypeEnum;
    value?: number;
    createdFrom: string;
    generationMode: CouponBatchDto.GenerationModeEnum;
    /**
     * Pre-generated batches: absolute expiration shared by every code.
     */
    expiresAt?: string | null;
    /**
     * On-demand batches: days between issuing a code and its expiration.
     */
    expiresInDays?: number | null;
    codesRequested: number;
    codesGenerated: number;
    autoImport: boolean;
    prefix: string;
    length: number;
    createdAt: string;
    updatedAt: string;
    codesAvailable: number;
}
export namespace CouponBatchDto {
    export const DiscountTypeEnum = {
        Fixed: 'fixed',
        Percentage: 'percentage',
        FreeShipping: 'free_shipping',
        BuyXGetY: 'buy_x_get_y'
    } as const;
    export type DiscountTypeEnum = typeof DiscountTypeEnum[keyof typeof DiscountTypeEnum];
    export const GenerationModeEnum = {
        PreGenerated: 'pre_generated',
        OnDemand: 'on_demand'
    } as const;
    export type GenerationModeEnum = typeof GenerationModeEnum[keyof typeof GenerationModeEnum];
}


